<script setup lang="ts">
import EditorTextField from '../../EditorTextField.vue'
import useBrandAppConfig from '../../../composables/useBrandAppConfig'
import { HOME_BLOCKS, HOME_BLOCK_TITLE_MAX_LENGTH, type HomeBlockId } from '../../../lib/brandAppContract'

const { t } = useI18n()
const props = defineProps<{
  blockId: HomeBlockId
}>()

const { home, setHomeBlockTitle } = useBrandAppConfig()

const defaultTitle = computed(() => HOME_BLOCKS.find((block) => block.id === props.blockId)?.defaultTitle ?? '')
const savedTitle = computed(() => home.value.blockTitles[props.blockId])

const customTitle = (value: string) => (value.trim() === defaultTitle.value ? '' : value)

const draft = ref(savedTitle.value ?? defaultTitle.value)

watch(savedTitle, (saved) => {
  if ((saved ?? '').trim() !== customTitle(draft.value).trim()) draft.value = saved ?? defaultTitle.value
})

watch(draft, (value) => setHomeBlockTitle(props.blockId, customTitle(value)))
</script>

<template>
  <EditorTextField
    :id="`brandApp.home.${blockId}.title`"
    v-model="draft"
    :label="t('pages.loyaltySupports.webapp.editor.home.titleLabel')"
    :max-length="HOME_BLOCK_TITLE_MAX_LENGTH"
    :placeholder="defaultTitle"
    :default-value="defaultTitle"
  />
</template>
